/* NATHALIE PULCINI — SHOPIFY THEME JS v1.0 */


document.addEventListener('DOMContentLoaded', function() {

  // ============================================================
  // MOBILE NAV
  // ============================================================
  window.toggleMobileNav = function() {
    var nav = document.getElementById('mobile-nav');
    if (!nav) return;
    nav.classList.toggle('open');
    document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
  };

  // ============================================================
  // CART SIDEBAR (Shopify Ajax Cart)
  // ============================================================
  window.toggleCart = function() {
    var sidebar = document.getElementById('cart-sidebar');
    var overlay = document.getElementById('cart-overlay');
    if (!sidebar) return;
    var isOpening = !sidebar.classList.contains('open');
    sidebar.classList.toggle('open');
    if (overlay) overlay.classList.toggle('open');
    if (isOpening) refreshCartDrawer();
  };

  // Fetch cart on open
  var cartBtn = document.querySelector('[data-cart-toggle]');

  // ============================================================
  // ACCORDION
  // ============================================================
  window.toggleAccordion = function(header) {
    var item = header.parentElement;
    item.classList.toggle('open');
  };

  // Use event delegation so it works for all sections, static and dynamic
  document.addEventListener('click', function(e) {
    var header = e.target.closest('.accordion-header');
    if (header) toggleAccordion(header);
  });

  // ============================================================
  // FILTER BUTTONS
  // ============================================================
  document.querySelectorAll('.filter-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var parent = this.closest('.filter-inner');
      if (parent) parent.querySelectorAll('.filter-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  document.querySelectorAll('.faq-cat-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var parent = this.closest('.faq-categories');
      if (parent) parent.querySelectorAll('.faq-cat-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ============================================================
  // BOOK PRICE OPTION TOGGLE
  // ============================================================
  document.querySelectorAll('.price-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      document.querySelectorAll('.price-option').forEach(function(o) { o.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ============================================================
  // TOAST NOTIFICATION
  // ============================================================
  window.showToast = function(msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 3000);
  };

  // ============================================================
  // ESC KEY HANDLERS
  // ============================================================
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var nav = document.getElementById('mobile-nav');
      var sidebar = document.getElementById('cart-sidebar');
      var overlay = document.getElementById('cart-overlay');
      if (nav) nav.classList.remove('open');
      if (sidebar) sidebar.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  // ============================================================
  // SHOPIFY AJAX ADD TO CART
  // ============================================================
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.dataset.variantId;
      var productTitle = this.dataset.productTitle || 'Produkt';
      if (!variantId) return;

      var defaultHtml = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Wird hinzugefügt...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        showToast('"' + productTitle + '" zum Warenkorb hinzugefügt');
        btn.disabled = false;
        btn.innerHTML = defaultHtml;
        refreshCartCount();
        refreshCartDrawer();
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        btn.disabled = false;
        btn.innerHTML = defaultHtml;
      });
    });
  });

  // ============================================================
  // CART COUNT REFRESH
  // ============================================================
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.getElementById('cart-count');
        if (badge) badge.textContent = cart.item_count;
      });
  }

  // ============================================================
  // CART DRAWER REFRESH
  // ============================================================
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var itemsEl = document.getElementById('cart-items');
        var footerEl = document.getElementById('cart-footer');
        var totalEl = document.getElementById('cart-total');
        if (!itemsEl) return;

        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<div class="cart-empty"><span class="cart-empty-icon"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></span><p>Dein Warenkorb ist noch leer.</p></div>';
          if (footerEl) footerEl.style.display = 'none';
          return;
        }

        if (footerEl) footerEl.style.display = 'block';
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

        var html = cart.items.map(function(item) {
          return '<div class="cart-item">' +
            '<div class="cart-item-thumb" style="background:var(--blush);">' +
              (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>') +
            '</div>' +
            '<div class="cart-item-info">' +
              '<div class="cart-item-name">' + item.product_title + '</div>' +
              '<div class="cart-item-variant">Menge: ' + item.quantity + '</div>' +
              '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
            '<button onclick="removeCartItem(\'' + item.key + '\')" style="color:var(--warm-mid);font-size:18px;cursor:pointer;padding:4px;background:none;border:none;">×</button>' +
          '</div>';
        }).join('');
        itemsEl.innerHTML = html;
      });
  }

  window.removeCartItem = function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function() {
      refreshCartCount();
      refreshCartDrawer();
    });
  };

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Init
  refreshCartCount();
});
